<template>
  <div>
    <!-- Header: Personal Info -->
    <div class="d-flex text-primary">
      <h4 class="mb-0 ml-50 text-primary">
        Selecciona para descargar tu reporte
      </h4>
    </div>

    <!-- Form: -->
    <validation-observer ref="simpleRules">
      <b-form class="mt-1">
        <b-row>
          <!-- Plan -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group>
              Plan:
              <v-select
                v-model="planFilter"
                :options="planOptions"
                :reduce="plan => plan.id"
                label="nombre"
                :value="planFilter"
                placeholder="Selecciona"
              >
                <template #no-options>
                  Selecciona un plan de estudios
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <!-- Periodo -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group>
              Periodo:
              <v-select
                v-model="periodoFilter"
                :options="periodos"
                :reduce="period => period.periodo"
                label="clave"
                :value="(periodoFilter === null)?'Selecciona un periodo válido':periodoFilter"
                placeholder="Selecciona"
              >
                <template #no-options>
                  Selecciona primero el plan de estudios
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <!-- curso -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group v-if="selectedtipo.value !== 1">
              Curso:
              <v-select
                v-model="cursoFilter"
                :options="cursosOptions"
                :reduce="curso => curso.id"
                label="materia"
                :value="(cursoFilter === null)?'Selecciona un curso válido':cursoFilter"
                placeholder="Selecciona"
              >
                <template #no-options>
                  Selecciona primero un periodo
                </template>
              </v-select>
            </b-form-group>
            <b-form-group
              v-else
              label="Tipo de periodo"
            >
              <b-form-radio-group
                v-model="selectedtipoperiodo"
                :options="TipoOptionsPeriodo"
                value-field="value"
                text-field="text"
                disabled-field="notEnabled"
                stacked
              />
            </b-form-group>
          </b-col>

          <!-- entre reportes -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group label="Tipo de reporte">
              <b-form-radio-group
                v-model="selectedtipo"
                :options="TipoOptions"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
                stacked
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group label="Tipo de alumno">
              <b-form-checkbox
                v-model="alumSelected"
                v-b-tooltip.hover.bottom="'Recuerda: Es necesario agendarlos, ya que de otra manera no podran tener calificación final, ni podrán continuar con el siguiente ciclo'"
                name="check-button"
                switch
                inline
              >
                Sin agenda
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <b-button
              :disabled="(cursoFilter !== null || selectedtipo.value === 1 )?false:true"
              variant="primary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              @click.prevent="descargaReporte()"
            >
              Descargar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  ref,
  onMounted,
  watch,
}
  from '@vue/composition-api'
import {
  BRow, BCol, BForm, BFormGroup, BButton, BFormRadioGroup, BFormCheckbox, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationObserver } from 'vee-validate'
import { periodsFromPlan } from '@/views/public/oferta-academica/useDetalleOferta'
import {
  useReportesCatalogos,
} from '@/views/campus/components/reportes/useReportes'
import { useToast } from 'vue-toastification/composition'
import { timestampToDate } from '@core/utils/filter'
import hostname from '@core/utils/http/config-hostname'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    vSelect,
    BFormGroup,
    BForm,
    BFormRadioGroup,
    ValidationObserver,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    loader: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const { loader } = props
    const selectedtipo = ref(0)
    const selectedtipoperiodo = ref('GENERACION')
    const alumSelected = ref(false)
    const TipoOptions = ref([
      { item: { formato: 'xlsx', value: 1 }, name: 'Específico por Primer o Ultimo Periodo Agendado', notEnabled: false }, // falta
      { item: { formato: 'xlsx', value: 2 }, name: 'Específico de  Estatus Académico por Asignatura', notEnabled: false },
      { item: { formato: 'pdf', value: 3 }, name: 'Calificación Final de Profesor', notEnabled: false },
      { item: { formato: 'pdf', value: 4 }, name: 'Calificación Final', notEnabled: false },
      { item: { formato: 'pdf', value: 5 }, name: 'Resolución CHYJ', notEnabled: false },
    ])
    const TipoOptionsPeriodo = ref([
      { value: 'GENERACION', text: 'Primer periodo agendado' },
      { value: 'EGRESADO', text: 'Último periodo agendado' },
    ])
    const periodos = ref([])
    const selectedCheckbox = ref(false)
    const periodoFilter = ref(null)
    const toast = useToast()
    const planFilter = ref(null)
    const cursoFilter = ref(null)
    const informacionReporte = ref([])
    const {
      planOptions, planOptionsPromise, cursosOptions, cursosOptionsPromise, reporteGralPromise, reporteEspecPromise, // reporteFinalPromise,
    } = useReportesCatalogos()
    const funcionarioOptions = [
      { text: 'Si', value: 'S' },
      { text: 'No', value: 'N' },
    ]

    const genderOptions = [
      { text: 'Masculino', value: 'M' },
      { text: 'Femenino', value: 'F' },
    ]
    function loadCursos() {
      if (periodoFilter.value != null) {
        cursosOptionsPromise(periodoFilter.value).then(response => {
          cursosOptions.value = response
        }, error => {
          if (error) {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Atención',
                text: 'En este momento no podemos entregar tu información. Intenta más tarde.',
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 9000 })
          }
        })
      }
    }
    function loadPeriodos() {
      // this.calendario = null
      periodos.value = []
      if (planFilter.value != null) {
        periodsFromPlan(planFilter.value).then(response => {
          periodos.value = response
          loadCursos()
        }, error => {
          if (error) {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Atención',
                text: 'En este momento no podemos entregar tu información. Intenta más tarde.',
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 9000 })
          }
        })
      }
    }
    watch(planFilter, () => {
      periodos.value = []
      periodoFilter.value = null
      loadPeriodos()
    })
    watch(periodoFilter, () => {
      cursosOptions.value = []
      cursoFilter.value = null
      loadCursos()
    })

    const getReporteGral = (resolve, reject) => { // llama al servicio de reporte general de status academico por generacion
      // servicio 5 en wsreportes
      let tipoAlum = 5
      if (alumSelected.value === true) {
        tipoAlum = 8
      }
      reporteGralPromise(planFilter.value, periodoFilter.value, tipoAlum, selectedtipoperiodo.value).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    }
    const getReporteEspec = (resolve, reject) => { // llama al servicio de reporte especifico de status academico
      // servicio  en wsreportes
      let tipoAlum = 6
      if (alumSelected.value === true) {
        tipoAlum = 9
      }
      reporteEspecPromise(planFilter.value, cursoFilter.value, tipoAlum).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    }
    function removeAccents(str) {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    }

    // eslint-disable-next-line no-unused-vars
    function JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
      // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      const arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData
      let CSV = ''
      let claves
      const datos = {}
      let row = ''

      // This condition will generate the Label/Header
      if (ShowLabel) {
        // This loop will extract the label from 1st index of on array
        claves = Object.keys(arrData[0])
        row = JSON.stringify(claves)
        row = row.substring(1, row.length - 1)
        // hasta aqui estan los titulos separados por comas
        CSV = `${row}\r\n`
      }
      let rows = ''
      let result = ''
      let bndAgregartitulos = true
      let categoria = ''
      let modulo = 0
      let nombre = ''
      const valorTempClaves = claves
      // // 1st loop is to extract each row
      for (let index = 0; index < arrData.length; index += 1) {
        rows = ' '
        for (let i = 0; i < valorTempClaves.length; i += 1) {
          // 2nd loop will extract each column and convert it in string comma-separated
          if (Array.isArray(arrData[index][valorTempClaves[i]])) {
            const newObjects = arrData[index][valorTempClaves[i]]
            // newObjects son todas las materias de un alumno
            // for recorre cada materia
            for (let indice = 0; indice < newObjects.length; indice += 1) {
              if (selectedtipo.value.value === 1) {
                let texto = ''
                switch (newObjects[indice].status) {
                  case 'NA':
                    texto = 'NO ACREDITADA'
                    break
                  case 'C1':
                    texto = 'CURSANDO'
                    break
                  case 'C2':
                    texto = 'RECURSANDO'
                    break
                  case 'C3':
                    texto = 'RECURSANDO'
                    break
                  case null:
                    texto = 'PENDIENTE'
                    break
                  case 'AP':
                    texto = newObjects[indice].cal_fin
                    break
                  default:
                    texto = ''
                    break
                }
                datos[`[Ciclo-${newObjects[indice].nombre.replace(/ /g, '').substring(0, 5)}][${indice + 1}]`] = true
                datos[` ${newObjects[indice].nombre} `] = texto

                rows += `"${(newObjects[indice].periodo === null) ? '-' : newObjects[indice].periodo}",`
                rows += `"${texto}",`
              } else if (selectedtipo.value.value === 2) {
                if (categoria !== newObjects[indice].categoryid) {
                  if (newObjects[indice].categoryid !== null) {
                    modulo += 1
                  }
                }
                if (nombre === newObjects[indice].name) { // por si hay itms con nombres repetidos no los omita
                // agrega un identificador
                  nombre = `${nombre} .`
                } else {
                  nombre = newObjects[indice].name
                }
                datos[` ${nombre}${newObjects[indice].categoryid !== null ? ' Mod. ' : ' '}    ${newObjects[indice].categoryid !== null ? modulo : ' '}`] = newObjects[indice].calificacion
                rows += `"${(newObjects[indice].calificacion === null) ? '-' : newObjects[indice].calificacion}",`
                categoria = newObjects[indice].categoryid
              }
            }
            if (bndAgregartitulos) {
              // const indiceAct = claves.indexOf('actividades') // filter(item => item === 'actividades')
              // claves.splice(indiceAct, 1)
              // const valorTemporal = claves
              claves += ','
              claves += Object.keys(datos)
              if (selectedtipo.value.value === 1) {
                claves = claves.replace(',asignaturas,', ',')
                claves = claves.replace(',promedio_global,', ',')
                claves = claves.replace(',estatus_general,', ',')
                claves = claves.replace(',ultimo_periodo,', ',')
                claves += ',promedio_general,estatus_general,ultimo_periodo'
              } else if (selectedtipo.value.value === 2) {
                claves = claves.replace(',actividades,', ',')
              }
              row = JSON.stringify(claves)
              result = row.substring(1, row.length - 1)
              bndAgregartitulos = false
              CSV = `${result}\r\n`
              // valorTempClaves.push(valorTemporal[0])
            }
            // CSV += `${rows}\r\n`
          } else {
            rows += `${(arrData[index][valorTempClaves[i]] === null) ? '' : arrData[index][valorTempClaves[i]]},`
          }
        }
        CSV += `${rows}\r\n`
      }
      if (CSV === '') {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'La consulta no genera ningún dato',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      } else {
        // Generate a file name
        let fileName = ''
        // this will remove the blank-spaces from the title and replace it with an underscore
        fileName += ReportTitle.replace(/ /g, '_')
        fileName = removeAccents(fileName)
        // Initialize file format you want csv or xls
        const uri = `data:text/xlsx;charset=utf-8,${escape(CSV)}",`// 'data:text/csv;charset=utf-8,' + escape(CSV);
        // Now the little tricky part.
        // you can use either>> window.open(uri);
        // but this will not work in some browsers
        // or you will not get the correct file extension
        // this trick will generate a temp <a /> tag
        const link = document.createElement('a')
        link.href = uri
        // set the visibility hidden so it will not effect on your web-layout
        link.style = 'visibility:hidden'
        link.download = `${fileName}.csv` // fileName + '.csv'
        // this part will append the anchor tag and remove it after automatic click
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }

    function loadPlan() {
      // loader.value.filters = true
      planOptionsPromise()
        .then(response => {
          planOptions.value = response
          // loader.value.filters = false
        })
        .catch(error => {
          // loader.value.filters = false
          // errorContent.value.filters = true
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Filtro de opciones para plan]',
              text: `${error} Descuida, puedes seguir trabajando con la tabla de resultados, nosotros vemos la manera de solucionar el inconveniente ;)`,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    const descargaReporte = () => {
      informacionReporte.value = []
      const promesa = new Promise((resolve, reject) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'Tu solicitud esta siendo procesada...',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 10000 })
        if (selectedtipo.value.value === 1) {
          loader.formulario = true
          emit('update:loader', loader)
          getReporteGral(resolve, reject)
        } else if (selectedtipo.value.value === 2) {
          loader.formulario = true
          emit('update:loader', loader)
          getReporteEspec(resolve, reject)
        } else if (selectedtipo.value.value === 3 || selectedtipo.value.value === 4) {
          const config = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes,width=700,height=800'
          const routeData = `${hostname().host}/app/reporte-calificacion/${planFilter.value}/${cursoFilter.value}/${periodoFilter.value}/${selectedtipo.value.value}`
          window.open(routeData, 'Impresión de reporte', config)
          // getReporteFinal(resolve, reject)
        } else if (selectedtipo.value.value === 5) {
          const config = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes,width=700,height=800'
          const routeData = `${hostname().host}/app/resolucion-chyj/${planFilter.value}/${cursoFilter.value}/${periodoFilter.value}/${selectedtipo.value.value}`
          window.open(routeData, 'Impresión de reporte', config)
        } else {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención',
              text: 'Porfavor selecciona el tipo de reporte que deseas',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 9000 })
        }
      })
      promesa
        .then(response => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención',
              text: 'Información entregada con éxito',
              icon: 'AlertCircleIcon',
              variant: 'success',
            },
          },
          { timeout: 9000 })
          informacionReporte.value = response
          if (selectedtipo.value.formato === 'xlsx') {
            if (typeof response === 'undefined') {
              informacionReporte.value.push(response)
            } else {
              informacionReporte.value = response
            }
            const currentDate = Math.floor(Date.now() / 1000)
            const diActual = timestampToDate(currentDate)
            let complemento = ''
            if (selectedtipo.value.value === 1) {
              complemento = 'Reporte_Gral_'
            } else if (selectedtipo.value.value === 2) {
              complemento = 'Reporte_Espec_'
            }
            const objCurso = cursosOptions.value.filter(item => item.id === cursoFilter.value)
            JSONToCSVConvertor(informacionReporte.value, `${complemento}${(objCurso[0] !== undefined) ? objCurso[0].materia : periodoFilter.value}_${diActual}`, true)
          }
          loader.formulario = false
          emit('update:loader', loader)
        })
        .catch(error => {
          loader.formulario = false
          emit('update:loader', loader)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 9000 })
        })
    }
    onMounted(() => {
      loadPlan()
      // obtenerAccesoCalif()
    })
    return {
      funcionarioOptions,
      genderOptions,
      periodos,
      periodsFromPlan,
      loadPeriodos,
      periodoFilter,
      planFilter,
      cursoFilter,
      informacionReporte,
      loadPlan,
      TipoOptions,
      TipoOptionsPeriodo,
      loadCursos,
      planOptions,
      alumSelected,
      descargaReporte,
      selectedCheckbox,
      cursosOptions,
      selectedtipo,
      selectedtipoperiodo,
      useToast,
      timestampToDate,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
